<template src="./Input.html"></template>
<style src="./Input.scss" lang="scss"></style>

<script>
	// TODO: length of suggest list must be as a variable instead of hardcoded magic-text in JS&CSS
	import Button from '@/components/Button/Button';
	import Icon from '@/components/Icon/Icon';
	import { Helper } from '@/services/helper/helper';

	/**
	 * The input elements used on the page.
	 * @vue-prop {Object} value An object containing information for input
	 * @vue-data {boolean} withButton If the input also has a button on the right side
	 * @vue-data {'' | 'primary' | 'accent' | 'input' } buttonImportance If the input also has a button on the right side
	 * @vue-data {boolean} buttonActive If the button in input is active
	 * @vue-data {number} pointer The index of the current pointer in suggest
	 * @vue-data {string} brand The current brand of the page
	 * @fires Input#input
	 * @fires Input#formsubmit
	 * @fires Input#formreset
	 */
	export default {
		name: 'HpInput',
		props: {
			value: {
				type: Object,
				required: true
			},
      hasIfta: {
			  type: Boolean,
        default: false
      }
		},
		data () {
			return {
				withButton: false,
				buttonImportance: 'input',
				buttonActive: false,
				pointer: -1,
				originValue: '',
				withoutSuggest: '',
				brand: ''
			};
		},
		watch: {
			// shouldn't watch the object value 'cause it never changes
			pointer () {
				this.$emit('input', this.value);
			}
		},
		methods: {
			/**
			 * Toggles the password visibility for password inputs.
			 */
			togglePasswordVisibility () {
				const trueType = this.$el.querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password';
				this.$el.querySelector('input').setAttribute('type', trueType);
				this.buttonActive = !this.buttonActive;
			},
			/**
			 * Fires formsubmit event with calling event as parameter.
			 * @param {Event} event The on click event from form submit button
			 */
			searchAction (event) {
				this.$emit('formsubmit', event);
			},
			/**
			 * Fires formreset event with calling event as parameter.
			 * @param {Event} event The on click event from form reset button
			 */
			searchReset (event) {
				event.preventDefault();
				this.value.suggest.response = [];
				this.$emit('formreset', event);
			},
			/**
			 * Checks input for text and starts adding suggestion layer after first letter.
			 * @returns {undefined} Early return value if no suggest is available.
			 */
			inputHandler () {
				if (this.value.suggest) {
					if (!this.value.inputvalue || !this.value.suggest || !this.value.suggest.url) {
						this.value.suggest.response = [];
						return undefined;
					}
				}
				// JS way of input length constraint
				let upperLimit = this.value.maxLength || 1024;
				if (this.value.inputvalue.length > upperLimit) {
					this.value.inputvalue = this.value.inputvalue.slice(0, upperLimit);
				}
				this.originValue = this.value.inputvalue;
				this.value.inputvalue.length &&
					Helper.xhr(this.value.suggest.url + this.value.inputvalue)
						.then((res) => {
							let response = JSON.parse(res.response.replace(/^suggest\(/i, '').replace(/].*;$/i, ']'));

							Object.entries(response).forEach(([key, value]) => {
								value.v = value.v.replace(this.value.inputvalue, '<span>' + this.value.inputvalue + '</span>');
							});

							this.value.suggest.response = response;
						})
						.catch((error) => {
							console.log('ERROR: ', error);
						});
			},
			/**
			 * Move the selection cursor up.
			 * @returns {undefined} Early return value if no suggestion list exists
			 */
			selectUp () {
				let list = document.querySelectorAll('#' + this.value.suggest.id + ' li') || [];
				if (!list.length) {
					return undefined;
				}
				let upperIndex = list.length > 5 ? 4 : list.length - 1;
				if (--this.pointer < -1) {
					this.pointer = upperIndex;
					this.value.inputvalue = list[this.pointer].textContent;
				} else if (this.pointer === -1) {
					this.value.inputvalue = this.originValue;
				} else {
					this.value.inputvalue = list[this.pointer].textContent;
				}
				this.value.index = this.pointer;
			},
			/**
			 * Move the selection cursor down.
			 * @returns {undefined} Early return value if no suggestion list exists
			 */
			selectDown () {
				let list = document.querySelectorAll('#' + this.value.suggest.id + ' li') || [];
				if (!list.length) {
					return undefined;
				}
				if (++this.pointer < list.length && Helper.isElementVisible(list[this.pointer])) {
					this.value.inputvalue = list[this.pointer].textContent;
				} else {
					this.pointer = -1;
					this.value.inputvalue = this.originValue;
				}
				this.value.index = this.pointer;
			},
			/**
			 * Sets attributes of the value prop
			 * @param {Event} event The click event on suggest click
			 * @param {string} val The new value.inputValue in prop
			 * @param {number} index The index value of the chosen suggest
			 * TODO: value should be removed, but also on BE side
			 */
			setValue (event, value, index) {
				this.value.index = index < 0 ? -1 : index;
				this.value.inputvalue = event.target.innerText;
				this.value.suggest.response = [];
				this.pointer = index < 0 ? -1 : index;
				setTimeout(() => {
					this.searchAction(event);
				}, 100);
			},
			/**
			 * I have no idea what this does.
			 * @param {Event} event The click event on the input field
			 */
			placeholderFocusOnce (event) {
				event.target.removeAttribute('data-placeholder-focus-once');
			}
		},
		created () {
			const brand = process.env.VUE_APP_BRAND;
			this.brand = brand === 'webde' ? 'WEB.DE' : brand === 'gmx' ? 'GMX' : '1&1';

			if (this.value.inputType === 'search') {
				if (brand === 'webde') {
					this.buttonImportance = 'primary';
				} else {
					this.buttonImportance = 'accent';
				}
			}
		},
		mounted () {
			this.$el.querySelector('input').setAttribute('type', this.value.inputType === 'search' ? 'text' : this.value.inputType);
			this.withoutSuggest = Helper.getElementByAttribute(this.$el, '[data-component="searchbar"]')?.hasAttribute('data-no-suggest');
			this.withButton = this.value.inputType === 'search' || this.value.inputType === 'password';
		},
		components: {
			'hp-button': Button,
			'hp-icon': Icon
		}
	};
</script>
